document.addEventListener("DOMContentLoaded", function () {
    const counters = document.querySelectorAll(".map__counter__number");

    counters.forEach(counterElement => {
        const targetNumber = parseInt(counterElement.getAttribute("data-number"));
        const suffix = counterElement.getAttribute("data-suffix");
        const duration = 5000; // Duration of the animation in milliseconds

        let observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    startCounter(counterElement, targetNumber, suffix);
                    observer.disconnect(); // Stop observing after animation starts
                }
            });
        });

        observer.observe(counterElement);

        function startCounter(element, target, suffix) {
            let start = 0;
            const increment = target / (duration / 16); // Increment based on 60fps

            function updateCounter() {
                start += increment;
                if (start < target) {
                    element.textContent = Math.ceil(start) + suffix;
                    requestAnimationFrame(updateCounter);
                } else {
                    element.textContent = target + suffix;
                }
            }

            updateCounter();
        }
    });
});